import {
  GET_SHIPPING_DATA_SUCCESS,
  GET_SHIPPING_DATA_FAIL,
  ADD_BOX_SIZE_SUCCESS,
  ADD_BOX_SIZE_FAIL,
  UPDATE_BOX_SIZE_SUCCESS,
  UPDATE_BOX_SIZE_FAIL,
  DELETE_BOX_SIZE_SUCCESS,
  DELETE_BOX_SIZE_FAIL,
  ADD_PRICE_SUCCESS,
  ADD_PRICE_FAIL,
  UPDATE_PRICE_SUCCESS,
  UPDATE_PRICE_FAIL,
  DELETE_PRICE_SUCCESS,
  DELETE_PRICE_FAIL,
  ADD_TAX_PRICE_SUCCESS,
  ADD_TAX_PRICE_FAIL,
  UPDATE_TAX_PRICE_SUCCESS,
  UPDATE_TAX_PRICE_FAIL,
  DELETE_TAX_PRICE_SUCCESS,
  DELETE_TAX_PRICE_FAIL,
  GET_MOSCOW_DATA_SUCCESS,
  GET_MOSCOW_DATA_FAIL,
  SHOW_LOADING,
  HIDE_LOADING
} from './actionTypes';

const INIT_STATE = {
  destinations: [],
  fedexPrices: [],
  emsPrices: [],
  taxPrices: [],
  agents: [],
  fees: [],
  boxSizes: [],
  countriesTr: [],
  variables: [],
  loading: false
};

const calculator = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SHIPPING_DATA_SUCCESS:
      return {
        ...state,
        destinations: action.payload[0],
        fedexPrices: action.payload[1],
        emsPrices: action.payload[2],
        agents: action.payload[3],
        fees: action.payload[4],
        boxSizes: action.payload[5],
        countriesTr: action.payload[6],
        taxPrices: action.payload[7]
      };
    case GET_SHIPPING_DATA_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case ADD_BOX_SIZE_SUCCESS:
      return {
        ...state,
        boxSizes: [...state.boxSizes, action.payload],
        success: { data: 'success' }
      };
    case ADD_BOX_SIZE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_BOX_SIZE_SUCCESS:
      return {
        ...state,
        boxSizes: state.boxSizes.map((service) => (service._id.toString() === action.payload._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' }
      };
    case UPDATE_BOX_SIZE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_BOX_SIZE_SUCCESS:
      return {
        ...state,
        boxSizes: state.boxSizes.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_BOX_SIZE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case ADD_PRICE_SUCCESS:
      return {
        ...state,
        fedexPrices: [...state.fedexPrices, action.payload],
        success: { data: 'success' }
      };
    case ADD_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_PRICE_SUCCESS:
      return {
        ...state,
        fedexPrices: state.fedexPrices.map((service) => (service._id.toString() === action.payload._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' }
      };
    case UPDATE_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_PRICE_SUCCESS:
      return {
        ...state,
        fedexPrices: state.fedexPrices.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    ///ADD TAX PRICES
    case ADD_TAX_PRICE_SUCCESS:
      return {
        ...state,
        taxPrices: [...state.taxPrices, action.payload],
        success: { data: 'success' }
      };
    case ADD_TAX_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case UPDATE_TAX_PRICE_SUCCESS:
      return {
        ...state,
        taxPrices: state.taxPrices.map((service) => (service._id.toString() === action.payload._id.toString() ? { service, ...action.payload } : service)),
        success: { data: 'success' }
      };
    case UPDATE_TAX_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case DELETE_TAX_PRICE_SUCCESS:
      return {
        ...state,
        taxPrices: state.taxPrices.filter((service) => service._id.toString() !== action.payload._id.toString())
      };
    case DELETE_TAX_PRICE_FAIL:
      return {
        ...state,
        error: action.payload
      };

    case GET_MOSCOW_DATA_SUCCESS:
      return {
        ...state,
        variables: action.payload
      };
    case GET_MOSCOW_DATA_FAIL:
      return {
        ...state,
        error: action.payload
      };
    case SHOW_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case HIDE_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    default:
      return state;
  }
};

export default calculator;
